export const selectTitleCheckResponse = (state) => state.titleCheck.titleCheckResponse;
export const selectTitleCheckLoadingState = (state) => state.titleCheck.isLoading;
export const selectTitleCheckError = (state) => state.titleCheck.error;
export const selectOpenSalvageAlert = (state) => state.titleCheck.openSalvageAlert;
export const selectMoveToNextTab = (state) => state.titleCheck.moveToNextTab;
export const selectTitlePdfLoading = (state) => state.titleCheck.pdfLoading;
